
define('template!webshopFiltersView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="list-pane">\n    <div class="list-header">\n        <input type="text" class="search" placeholder="' +
((__t = ( _.i18n('webshop.filters.search', null, 'Search a filter (name, code, id)') )) == null ? '' : __t) +
'"/>\n        <div class="add-region"></div>\n    </div>\n    <div class="list-region"></div>\n</div>\n<div class="detail-region">\n    <div class="detail-placeholder">' +
((__t = ( _.i18n('webshop.filters.selectFilter', null, 'Select a filter to see its values and products') )) == null ? '' : __t) +
'</div>\n</div>\n';

}
return __p
};});

